import { render, staticRenderFns } from "./DetailsEvent.vue?vue&type=template&id=1a4b31df&"
import script from "./DetailsEvent.vue?vue&type=script&lang=js&"
export * from "./DetailsEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports